module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point04_02_activity-0abf2c329b8e80316dd9059266b68e94.jpg";